import React from 'react';

export function UserDetails() {
  return <h1>UserDetail</h1>;
}
